"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = App;
require("font-awesome/css/font-awesome.css");
require("react-toastify/dist/ReactToastify.css");
require("./styles/cun.scss");
require("./styles/eso.scss");
require("./styles/hpv.scss");
require("./styles/hpvcun.scss");
require("./styles/gcm.scss");
require("./styles/lcm.scss");
require("./styles/ad.scss");
require("./styles/pc.scss");
require("./styles/result-forms.scss");
require("./styles/confirm.scss");
require("./styles/hospital.scss");
// import "./styles/grid.scss";
// import "./styles/modal.css";
require("./styles/orderform.scss");
require("./styles/login.scss");
require("./styles/page.scss");
require("./styles/modal1.scss");
var react_1 = __importStar(require("react"));
var react_toastify_1 = require("react-toastify");
var grid_1 = require("./grid");
var grid_ctx_1 = require("./contexts/grid_ctx");
var login_1 = require("./login");
var nav_1 = require("./forms/nav");
var user_ctx_1 = require("./contexts/user_ctx");
function GridBoard() {
    return (react_1.default.createElement("div", { className: "zmsk-grid-board" },
        react_1.default.createElement(nav_1.Nav, null),
        react_1.default.createElement(grid_ctx_1.GridProvider, null,
            react_1.default.createElement(grid_1.Grid, null)),
        react_1.default.createElement("div", { className: "toast-container" },
            react_1.default.createElement(react_toastify_1.ToastContainer, null))));
}
function Board() {
    var userinfo = (0, react_1.useContext)(user_ctx_1.UserContext).userinfo;
    if (userinfo.username) {
        return react_1.default.createElement(GridBoard, null);
    }
    else {
        return react_1.default.createElement(login_1.LoginBoard, null);
    }
}
function App() {
    var _a = (0, react_1.useState)(react_1.default.createElement(react_1.default.Fragment, null)), node = _a[0], setNode = _a[1];
    var userinfo = (0, react_1.useContext)(user_ctx_1.UserContext).userinfo;
    (0, react_1.useEffect)(function () {
        setNode(react_1.default.createElement(Board, null));
    }, [userinfo]);
    return (react_1.default.createElement(react_1.default.StrictMode, null,
        react_1.default.createElement(user_ctx_1.UserProvider, null,
            node,
            userinfo.username)));
}
